export default __webpack_public_path__ + "static/media/Grass.c8fbf8b3.jpg";